import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'ResetPassword';

/**
 * Errors related to the Reset Password page
 */
export const Errors = createErrors<Page, Component>('ResetPassword')({
    ResetPassword: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to reset password',
        },
    },
    ChangePassword: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to change password',
        },
    },
});
